
<template>
  <div class="event-lists gift d-flex flex-wrap justify-content-between">
    <div v-if="showSortSpinner" class="spinner">
      <div class="spinner-border" role="status"></div>
    </div>
    <div
      class="registry-lists d-flex flex-wrap w-100"
      v-for="(gift, index) in giftList"
      v-bind:key="gift._id"
      :giftList="giftList"
    >
      <!-- MY AD - 01/01/2017 -->

      <div class="event-img">
        <img v-if="gift.productImage[0]" :src="gift.productImage[0].image">
        <img v-else src="../../../public/assets/images/event1.png">

        <div class="purchasedOverlay" v-if="isExpired===true && (gift.giftPurchasedBy.length > 0)">
          <!-- only show guest list to the event owner -->
          <p v-if="gift.giftAddedBy.userId == userDetails._id">
            <span>{{gift.giftPurchasedBy.map(item => (item.userId ? item.userId : item._id) === userDetails._id ? 'You' : item.name).splice(0,2).join(', ')}}</span>
            <span
              v-show="(gift.giftPurchasedBy.length - 2) > 0"
            >+ {{ gift.giftPurchasedBy.length - 2 }} more</span>
            <span> purchased this gift.</span>
          </p>
          <p v-else>This event is over.</p>
        </div>
        <div class="purchasedOverlay" v-if="isExpired === false && gift.remainingQuantity == 0">
          <p>This gift has been purchased</p>
        </div>
      </div>
      <div
        class="event-info flex-grow-1"
        v-bind:class="{ bgWhite: ((index%2) !== 0 || index == 1) }"
      >
        <div class="row">
          <div class="giftTitle">
            <a @click="openGiftDetailsModal(gift)">
              <h4>{{gift.productName}}</h4>
            </a>
          </div>
          <div class="giftAction">
            <div class="purchase-details" v-if="!(gift.giftPurchasedBy.length)">
              <a @click="openGiftDetailsModal(gift)">Claim as purchased</a>
            </div>
            <div class="purchase-details" v-else>
              <div v-if="gift.remainingQuantity == 0 /*&& user.includes(userDetails._id)*/">
                <i class="far fa-check-circle"></i>
                <span>Already purchased</span>
              </div>
              <div v-else-if="gift.giftPurchasedByArray.includes(userDetails._id)">
                <i class="far fa-check-circle"></i>
                <span @click="openGiftDetailsModal(gift)">I have purchased</span>
              </div>

              <a v-else @click="openGiftDetailsModal(gift)">Claim as purchased</a>
            </div>
          </div>
          <div class="dropdown" v-if="gift.giftAddedBy.userId == userDetails._id">
            <!--check if the logged in user is the owner of gift -->
            <span
              class="dropdown-toggle"
              type="button"
              id="dropdownMenuButton"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            ></span>
            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
              <a class="dropdown-item" @click="openEditGiftModal(gift)">Edit</a>
              <a class="dropdown-item" @click="deleteGiftModal(gift._id)">Delete</a>
            </div>
          </div>
        </div>
        <gift-details
          :show="showGiftDetailsModal"
          :showPurchasedAmount="showPurchasedAmount"
          @closeGiftDetailsModal="closeGiftDetailsModal"
          :isExpired="isExpired"
          :celebrantName="celebrantName"
        ></gift-details>
        <p class="where-to-buy">{{gift.want}}</p>
        <p class="where-to-buy"><a target="_blank" v-bind:href="gift.whereToBuy">{{gift.whereToBuy}}</a></p>
        <div class="row">
          <div class="column col-md-4">
            <p class="price" v-if="gift.productPrice">${{gift.productPrice}}</p>
            <p class="price" v-else>$0</p>
          </div>
          <div class="column col-md-8">
            <p class="list-head">More details</p>
          </div>
        </div>
        <div class="row">
          <div class="column col-md-2">
            <!--<p class="list-head">Color</p>-->
            <p class="list-head">Size</p>
            <p class="list-head">QTY</p>
          </div>
          <div class="column col-md-2">
            <!-- <p class="details" v-if="gift.productColor">{{gift.productColor}}</p>
            <p class="details" v-else>&nbsp;</p>-->

            <p class="details" v-if="gift.productSize">{{gift.productSize}}</p>
            <p class="details" v-else>&nbsp;</p>

            <p class="details" v-if="gift.productQuantity">{{gift.productQuantity}}</p>
            <p class="details" v-else>&nbsp;</p>
          </div>
          <div class="column col-md-8">
            <p class="more-detail">{{gift.detail}}</p>
          </div>
        </div>
      </div>
    </div>

    <edit-gift :show="showEditGiftModal" @close="closeEditGiftModal"></edit-gift>

    <!-- DELETE GIFT MODAL BEGINS-->
    <div
      class="modal fade"
      id="delete-gift-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">Are you sure?</div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default btn-sm" data-dismiss="modal">No</button>
            <button type="button" class="btn btn-outline-success btn-sm" @click="confirmTrue">Yes</button>
          </div>
        </div>
      </div>
    </div>
    <!-- DELETE GIFT MODAL ENDS -->
    <div v-if="showSpinner" class="spinner">
      <div class="spinner-border" role="status"></div>
    </div>
    <button
      class="view-all btn btn-default"
      @click="viewAllGift"
      v-show="showViewButton && totalDocs>3"
    >View all</button>
  </div>
</template>

<script>
import {
  GIFT_LIST,
  SET_GIFT_DETAILS,
  DELETE_GIFT
} from "../../store/gift/action.type";
import GiftDetails from "./GiftDetails";
import EditGift from "./EditGift";
import { mapState, mapGetters } from "vuex";
export default {
  components: {
    "gift-details": GiftDetails,
    "edit-gift": EditGift
  },
  props: ["isExpired", "celebrantName", "want", "purchased"],
  data() {
    return {
      giftList: "",
      showGiftDetailsModal: false,
      giftId: "",
      purchasedQuantity: 0,
      userId: "",
      user: [],
      apiSuccessMessage: "",
      apiErrorMessage: "",
      showAlertMessage: false,
      showSuccessAlertMessage: false,
      wishlistId: this.$route.params.id,

      /* Edit Gift data */
      showEditGiftModal: false,

      /* List all gifts */
      totalPages: 0,
      page: 1,
      perPageLimit: process.env.VUE_APP_API_PER_PAGE_LIMIT || 3,
      showViewButton: true,
      totalDocs: 0,
      showSpinner: false,
      showPurchasedAmount: false,
      showSortSpinner: false,
      desirability: ""
    };
  },

  computed: {
    ...mapState({
      userDetails: state => state.auth.userDetails
    }),

    ...mapGetters(["getGiftDetails"])
  },
  mounted() {
    this.checkPurchasedDetails();
  },
  methods: {
    checkPurchasedDetails() {
      this.showSortSpinner = true;
      let params = {
        page: this.page,
        perPageLimit: this.perPageLimit,
        wishlistId: this.wishlistId,
        sortBy: this.want,
        purchased: this.purchased
      };
      this.$store
        .dispatch(GIFT_LIST, params)
        .then(response => {
          if (response.status === 200) {
            this.giftList = response.data.data.record;
            this.totalDocs = response.data.data.pagination.totalDocs; //set the total result from response
            this.giftList.filter(gift => {
              //filter gift owner for displaying name of gift purchaser
              //unshift logged in user to display as 'You'
              let filteredOwner = gift.giftPurchasedBy.filter(
                item => item.userId !== gift.giftAddedBy.userId
              );
              let loggedInUserIndex = filteredOwner.findIndex(
                item => {item.userId === this.userDetails._id; console.log(item, this.userDetails._id)}
              );

              if (loggedInUserIndex > -1) {
                filteredOwner.splice(loggedInUserIndex, 1);
                filteredOwner.unshift(this.userDetails);
              }
              gift.giftPurchasedBy = filteredOwner;

              gift.want = this.setUserDesirability(gift.wantPriority);
            });
          }
          this.showSortSpinner = false;

          // this.giftList.filter((item, index) => {
          //   item.giftPurchasedBy.filter((items, indexes) => {
          //     this.userId = items.userId == this.userDetails._id; //set the userId to true or false by comparing logged in user id and userId from giftPurchasedBy array in response
          //     this.user = [...new Set(item.giftPurchasedBy.map(x => x.userId))]; //set unique userId from giftPurchasedBy array from response to user array
          //   });
          // });
          if (response.status === 204) {
            this.totalDocs = 0;
            this.giftList = "";
          }
        })
        .catch(error => {
          this.giftList = "";
        });
    },

    /* METHODS FOR GIFT DETAILS */
    openGiftDetailsModal(gift) {
      this.$store.dispatch(SET_GIFT_DETAILS, gift);
      this.showGiftDetailsModal = true;
      this.showPurchasedAmount = true;
    },

    closeGiftDetailsModal(quantity, giftId, giftPurchasedBy) {
      this.showGiftDetailsModal = false;
      this.showSuccessAlertMessage = false;
      this.showAlertMessage = false;
      this.purchasedQuantity = quantity;
      this.checkPurchasedDetails(); //check if logged in user has purchased the gift after the modal is closed to update the gift list
    },

    /* METHODS FOR GIFT EDIT */
    openEditGiftModal(gift) {
      this.$store.dispatch(SET_GIFT_DETAILS, gift);
      this.showEditGiftModal = true;
    },
    closeEditGiftModal() {
      this.showEditGiftModal = false;
      this.checkPurchasedDetails(); //check if logged in user has purchased the gift after the modal is closed to update the gift list
    },

    /* METHODS FOR GIFT DELETE */
    deleteGiftModal(giftId) {
      this.giftId = giftId;
      $("#delete-gift-modal").modal("show");
    },

    confirmTrue() {
      $("#delete-gift-modal").modal("hide");
      this.$store
        .dispatch(DELETE_GIFT, this.giftId)
        .then(response => {
          if (response.status == 200) {
            this.apiSuccessMessage = response.data.message;
            this.showSuccessAlertMessage = true;
            this.$router.go(this.$router.currentRoute);
          } else {
            this.apiErrorMessage = response.data.message;
            this.showAlertMessage = true;
          }
        })
        .catch(error => {
          this.apiErrorMessage = error.response.data.message;
          this.showAlertMessage = true;
        });
    },
    viewAllGift() {
      this.showSpinner = true;
      let params = {
        page: this.page,
        perPageLimit: this.totalDocs,
        wishlistId: this.wishlistId,
        sortBy: this.want,
        purchased: this.purchased
      };
      this.$store
        .dispatch(GIFT_LIST, params)
        .then(response => {
          if (response.status === 200) {
            this.giftList = response.data.data.record;
            this.perPageLimit = response.data.data.pagination.totalDocs; //change perPageLimit value to totalDocs value so that on closing giftDetailsModal all gifts are listed in case of all gifts being viewed

            this.giftList.filter(gift => {
              let filteredOwner = gift.giftPurchasedBy.filter(
                item => item.userId !== gift.giftAddedBy.userId
              );
              let loggedInUserIndex = filteredOwner.findIndex(
                item => item.userId === this.userDetails._id
              );
              if (loggedInUserIndex > -1) {
                filteredOwner.splice(loggedInUserIndex, 1);
                filteredOwner.unshift(this.userDetails);
              }
              gift.giftPurchasedBy = filteredOwner;
              gift.want = this.setUserDesirability(gift.wantPriority);
            });

            this.showSpinner = false;
          }
        })
        .catch(error => {
          console.log(error);
          this.showSpinner = false;
        });
      this.showViewButton = false;
    },

    setUserDesirability(wantPriority) {
switch (wantPriority) {
                case 1:
                  return `${this.celebrantName} really wants this.`;
                  break;

                case 2:
                  return `${this.celebrantName} must have this.`;
                  break;

                case 3:
                  return `${this.celebrantName} wants this.`;
                  break;

                case 4:
                  return `${this.celebrantName} finds this useful.`;
                  break;

                case 5:
                  return `${
                    this.celebrantName
                  } has no preference for this.`;
                  break;

                default:
                  break;
              }
    }
  },
  watch: {
    showAlertMessage(newData) {
      if (newData) {
        var self = this;
        setTimeout(function() {
          self.showAlertMessage = false;
        }, 2000);
      }
    },
    showSuccessAlertMessage(newData) {
      if (newData) {
        var self = this;
        setTimeout(function() {
          self.showSuccessAlertMessage = false;
        }, 2000);
      }
    },

    want: function() {
      this.checkPurchasedDetails();
    },

    purchased: function() {
      this.checkPurchasedDetails();
    }
  }
};
</script>
<style scoped>
.giftTitle{
  word-wrap:anywhere;
}
.event-info p {
  font-size: 1.125rem;
  line-height: 1.625rem;
  color: #3f3d55;
}

.list-head {
  color: #6d5b97 !important;
}

.where-to-buy {
  color: #6d5b97 !important;
  opacity: 0.7;
  margin: 2px;
  max-height: 50px;
  overflow-y: auto;
  overflow-x: hidden;
  margin-bottom: 10px;
  scrollbar-width: thin;
}

.more-detail {
  margin-top: 10px;
  max-height: 100px;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: thin;
}
.price {
  color: #fd3e75 !important;
  font-family: "Rubik light";
}
::-webkit-scrollbar {
  height: 10px;
  width: 4px;
  background: #ddd;
}

::-webkit-scrollbar-thumb {
  background: rgb(143, 141, 141);
  -webkit-border-radius: 1ex;
  /* -webkit-box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.75); */
}

::-webkit-scrollbar-corner {
  /* background: #000; */
}

.event-info button:after {
  content: "";
  display: inline-block;
  width: 0;
  height: 0;
  border-left: 0.5rem solid #fd3e75;
  border-top: 0.5rem solid transparent;
  border-bottom: 0.5rem solid transparent;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  -ms-border-radius: 3px;
  border-radius: 3px;
  -moz-transform: rotateX(180deg);
  -o-transform: rotateX(180deg);
  -ms-transform: rotateX(180deg);
  -webkit-transform: rotateX(180deg);
  transform: rotateX(180deg);
  -moz-transition: 0.3s ease all;
  -o-transition: 0.3s ease all;
  -ms-transition: 0.3s ease all;
  -webkit-transition: 0.3s ease all;
  transition: 0.3s ease all;
  right: 0;
  margin-left: 103px;
}

.details {
  margin-top: 10px;
}
.purchase-details {
  color: #fd3e75;
  margin-top: 5px;
  margin-left: 15px;
}

.purchase-details a {
  color: #fd3e75;
}
.fa-check-circle {
  margin-right: 11px;
}
.event-img {
  position: relative;
}
.event-img .purchasedOverlay {
  position: absolute;
  color: #fff;
  font-size: 1.281rem;
  width: 100%;
  border-radius: 0.75rem 0 0;
  top: 0;
  bottom: 0;
  display: block;
  background: rgba(0, 0, 0, 0.42);
}
.event-img .purchasedOverlay p {
  margin-top: 50%;
  text-align: center;
}
</style>